import { render } from "./LEDControlPanel.vue?vue&type=template&id=4f2f84b9&scoped=true"
import script from "./LEDControlPanel.vue?vue&type=script&lang=js"
export * from "./LEDControlPanel.vue?vue&type=script&lang=js"

import "./LEDControlPanel.vue?vue&type=style&index=0&id=4f2f84b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2f84b9"]])

export default __exports__